module.exports = __webpack_public_path__ + "static/media/star-regular.a7b61153.svg";